import React, {Component} from 'react'

import MaskInput from '../../../../shared/components/MaskInput'
import withValidation from '../../../../container/withValidation'
import moment from 'moment'
import CustomTextField from '../CustomTextField'

class ExpirationMonthInput extends Component {

    constructor(props) {
        super(props)

        this.state = {
            value: ""
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e) {
        const inputValue = e.target.value;
        const date = moment(inputValue, "MM/YY")
        let newState = {
            ...this.state,
            value: inputValue,
            card_expiration_month: date.format("MM"),
            card_expiration_year: date.format("YY")
        };
        this.setState(newState)
        this.props.updateCardData(newState)
        this.props.onChange(e)
    }

    render() {
        const {error, errorMessage, tabIndex, ...restOfProps} = this.props

        return (
            <React.Fragment>
                <MaskInput
                    mask="99/99"
                    onPaste={e => e.preventDefault()}
                    {...restOfProps}
                    onChange={this.handleChange}
                >
                    <CustomTextField
                        id="cardExpiration"
                        label="Vencimiento"
                        type="text"
                        helperText="Formato MM/AA"
                        error={error}
                        errorMessage={errorMessage}
                        tabIndex={tabIndex}
                    />
                </MaskInput>
            </React.Fragment>
        )
    }

}

const validation = (value) => {

    if(value.length === 0) return {
        isValid: false,
        message: "Completa este dato"
    }

    const valid = value.match(/^[0-9]{2}\/[0-9]{2}$/)
         && moment().isBefore(moment(value, "MM/YY").endOf('month'))

    return {
        isValid: valid,
        message: valid ? "" : "Encontramos un error en este dato"
    }
}

export default withValidation(validation)(ExpirationMonthInput)
